/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface PropertiesProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a properties provider for contributing a list of properties and property layouts.
 */
define([], () => {
	class CachingPropertiesProviderAPI {

		/**
		 * @function CachingPropertiesProviderAPI#reset
		 * @description Clears any cached properties
		 */
		reset() { }

	}

	return CachingPropertiesProviderAPI;
});